export const BRAND = {
  name: "𝕮𝖔𝖒𝖋𝖔𝖗𝖙 𝓚𝖎𝖑𝖑𝖘 𝓚𝖎𝖓𝖌𝖘",
  words: ["𝕮𝖔𝖒𝖋𝖔𝖗𝖙", "𝓚𝖎𝖑𝖑𝖘", "𝓚𝖎𝖓𝖌𝖘"],
  short: "𝕮𝒳𝑀𝒳𝐼𝐼𝕸𝒪𝐵𝐁 ﾒ 𝔚𝒪𝑅𝐿𝒟𝒲𝐼𝒟𝐸",
  instagram: "https://instagram.com/comfortkillskings",
  instagramHandle: "@comfortkillskings",
};

export const LOGOS = {
  wordmark: "/brand/logo-wordmark.webp",
  emblem: "/brand/logo-emblem.webp",
  monogram: "/brand/logo-monogram.webp",
  campaign: "/brand/logo-campaign.webp",
};

export const DROP_DATE = "2026-10-29T20:00:00-04:00";

export const API = `${process.env.REACT_APP_BACKEND_URL}/api`;
